<template>
  <div class="flex-center h-full">
    <!-- 安装引导 -->
    <slot :start :status />

    <van-popup v-model:show="showPwaInstallation" v-if="!finishedInstall" :close-on-click-overlay="false">
      <div class="detect p-5 bg-[#151A1FB2] rounded-[10px] text-center flex-center-col-x bd-[2px_var(--theme-primary)] w-[340px] text-15">
        <processing v-if="status == Status.START_CHECK" msg="Detecção do ambiente de instalação..." :time="config.detectTime" @finished="finishedDetect = true"/>

        <template v-else-if="status == Status.CHECK_SUCCESS">
          <div class="flex-center-y mb-5 text-white">
            <img src="@a/assets/images/i_checked.png" class="size-6 mr-1.5" alt="" />
            Detecção bem-sucedida
          </div>
          <div @click="installPWA" class="primaryBtn">Instalar agora</div>
        </template>

        <processing v-else-if="status == Status.USER_ACCEPTED" msg="Em instalação" :time="config.installTime" @finished="onFinishedInstall"/>

        <div v-else-if="status == Status.CHECK_FAILED" class="text-white">
          Falha na detecção do ambiente de instalação
        </div>
      </div>
    </van-popup>

    <!--ios添加到主屏 -->
    <van-popup v-model:show="showAddToHomeScreen" position="bottom">
      <div class="relative">
        <img src="@a/assets/images/download_ios_pt.png" class="w-full" alt="" />
        <div @click="showAddToHomeScreen = false" class="size-[50px] absolute-rt-0"> </div>
      </div>
    </van-popup>
  </div>
</template>

<script setup lang="ts">
  import config from '@/config'
  import usePWA, { Status } from '@/hooks/usePWA'
  import processing from './processing.vue'
  import useInstall from '@/hooks/useInstall'

  const { readyToInstall, status, installPWA } = usePWA()

  const { showAddToHomeScreen, install } = useInstall()

  const start = () => {
    if (finishedInstall.value) {
      onFinishedInstall()
      return
    }
    
    if (status.value == Status.CHECK_FAILED) {
      showPwaInstallation.value = true
      setTimeout(() => {
        showPwaInstallation.value = false
      }, 3000)
      return
    }

    install(async () => {
      if (status.value == Status.NOT_STARTED) status.value = Status.START_CHECK
      showPwaInstallation.value = true
    })
  }

  const onFinishedInstall = () => {
    finishedInstall.value = true
    showToast({
      message: 'Instalação bem-sucedida',
      duration: 3000,
      iconSize: 30,
      icon: 'success',
      zIndex: 9999
    })
  }

  const showPwaInstallation = ref(false)
  const finishedDetect = ref(false)
  const finishedInstall = ref(false)

  watch([readyToInstall, finishedDetect], ([newReadyToInstall, newFinishedDetect]) => {
    if (newReadyToInstall) {
      // 检测成功
      status.value = Status.CHECK_SUCCESS
      finishedDetect.value = true

    } else if (newFinishedDetect) {
      // 检测失败
      status.value = Status.CHECK_FAILED
      
      setTimeout(() => {
        showPwaInstallation.value = false
      }, 3000)
    }
  }, { immediate: true })
</script>

